import Vue from 'vue'

const state = {
  bundleFilter: null,
  groupFilter: null,
  sortBy: 'stock',
  sortDesc: true,
}

const mutations = {
  setGroupFilter (state, newFilter) {
    Vue.set(state, 'groupFilter', newFilter)
  },
  setBundleFilter (state, newFilter) {
    Vue.set(state, 'bundleFilter', newFilter)
  },
  setSortBy (state, newSortBy) {
    Vue.set(state, 'sortBy', newSortBy)
  },
  setSortDesc (state, newSortDesc) {
    Vue.set(state, 'sortDesc', newSortDesc)
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}

